<template>
  <div class="h5-partner-share-wrapper">
    <label class="title">我的邀请海报，长按保存、分享给好友</label>

    <canvas id="canvas" class="canvas">抱歉，您的浏览器不支持canvas元素</canvas>
    <img class="poster-image" :src="posterURL" />
  </div>
</template>

<script>
import posterBase from '../../../assets/h5/poster-base.png'
import Notes from '@/engine/Notes'
import { utils } from '@/util/index'

import Menu from '@/components/h5/Menu.vue'

const drawPoster = (vm, image, qrUrl) => {
  const canvas = document.getElementById('canvas')
  canvas.width = 640
  canvas.height = 1008
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = image
    img.onload = () => {
      ctx.drawImage(img, 0, 0)

      const qr = new Image()
      qr.setAttribute('crossOrigin', 'Anonymous')
      qr.src = qrUrl
      qr.onload = () => {
        ctx.drawImage(qr, 420, 740, 150, 150)

        try {
          vm.posterURL = canvas.toDataURL('image/png')
        } catch (error) {
          console.error(JSON.stringify(error))
        }
      }
    }
  }
}

export default {
  name: 'h5Share',
  components: {
    Menu,
  },
  data () {
    return {
      posterURL: '',
    }
  },
  mounted () {
    Notes.generatePartnerMpQrCode().then(async ({ url }) => {
      drawPoster(this, posterBase, url)
    })
  },
  methods: {
    onChangeMenu: function (id) {
      this.menus = this.menus.map((item, index) => {
        if (item.id === id) {
          this.menuActiveIndex = index
        }
        return {
          ...item,
          active: item.id === id,
        }
      })
    },
    copy: function () {
      this.$copyText(this.link).then(() => {
        this.$toast('链接复制成功')
      }, () => {
        this.$toast('链接复制失败，请刷新后重试！')
      })
    },
  },
};
</script>

<style lang="scss">
.h5-partner-share-wrapper {
  text-align: center;

  .title {
    display: block;
    padding: 20px 0;
  }

  .canvas {
    position: fixed;
    left: 200%;
    top: 200%;
  }

  .poster-image {
    display: block;
    width: 80vw;
    margin: 0 auto;
  }
}
</style>
